import { create } from "zustand";

export const ThoughtSpotStatus = {
  Authenticated: "authenticated",
  Pending: "pending",
  Failed: "failed",
} as const;
export type ThoughtSpotStatus = (typeof ThoughtSpotStatus)[keyof typeof ThoughtSpotStatus];

export type ThoughtSpotStatusStore = {
  status: ThoughtSpotStatus;
  setStatus: (status: ThoughtSpotStatus) => void;
};

export const useThoughtSpotStatusStore = create<ThoughtSpotStatusStore>((set) => ({
  status: ThoughtSpotStatus.Pending,
  setStatus: (status: ThoughtSpotStatus) => {
    set({ status });
  },
}));
